import React from "react";
import {Outlet} from "react-router-dom";
import {Header} from "../header/Header";
import {Footer} from "../footer/Footer";
import styles from './MainLayout.module.css';

export function MainLayout() {

    return (
        <>
            <Header/>
            <div className={styles.pt80}>
                <Outlet />
            </div>
            <Footer/>
        </>
    );
}
